module.exports = __webpack_public_path__ + "img/bg.9da91ae9.png";